import(/* webpackMode: "eager", webpackExports: ["About"] */ "/vercel/path0/frontend_next/src/screens/user/About.tsx");
